var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-loading",style:({
    height: `${_vm.height}px`
  })},[_c('div',[_vm._m(0),_c('div',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.msg))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":"https://ptegofeifan.oss-accelerate.aliyuncs.com/go/admin_file_1633544847158742325086.png","alt":""}})])
}]

export { render, staticRenderFns }